import {
  MESSAGING_PROMPT_REQUEST_STORAGE_KEY,
  MESSAGING_PROMPT_REQUEST_TTL_MS,
  messagingPromptRequestSchema,
} from "@/lib/messagingPromptRequest";

/** Reads one unhandled, unexpired contextual prompt request for an authenticated viewer. */
export function readMessagingPromptRequest(viewerScope: string | undefined) {
  if (typeof window === "undefined" || !viewerScope) return null;

  try {
    const raw = window.localStorage.getItem(MESSAGING_PROMPT_REQUEST_STORAGE_KEY);
    const parsed = raw ? messagingPromptRequestSchema.safeParse(JSON.parse(raw)) : null;
    if (!parsed?.success) return null;
    if (parsed.data.requestedAt + MESSAGING_PROMPT_REQUEST_TTL_MS > Date.now()) {
      return parsed.data;
    }

    window.localStorage.removeItem(MESSAGING_PROMPT_REQUEST_STORAGE_KEY);
    return null;
  } catch {
    return null;
  }
}
